module.exports = __webpack_public_path__ + "static/img/ic_google@4x.82293a0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/ic_google@4x.png
// module id = taI4
// module chunks = 1